import { Label, UIText1 } from '@cian/ui-kit';
import { IconFunctionalLock16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as style from './style.css';
import { INewbuildingLayoutOffer } from '../../../../types/residentialComplexLayouts/layoutWithOffers/offer';

interface IOffersRowProps {
  offer: INewbuildingLayoutOffer;
  onOfferLinkClick(): void;
}

export const OffersRow = ({ offer, children, onOfferLinkClick }: React.PropsWithChildren<IOffersRowProps>) => {
  const {
    priceText,
    oldPriceText,
    discountLabel,
    isBookedFromDeveloper,
    singleOfferUrl,
    title,
    hasDecoration,
    buildingDeadlineShorten,
    floor,
  } = offer;

  return (
    <div data-testid="NewbuildingLayoutsOffer" className={style['row']}>
      <a
        className={style['inner-row']}
        href={singleOfferUrl}
        onClick={onOfferLinkClick}
        target="_blank"
        rel="noreferrer"
      >
        <div className={style['offer-title']}>
          <UIText1 color="text-main-default">{title}</UIText1>

          <div className={style['labels']}>
            {isBookedFromDeveloper && (
              <Label background="accent-ghost-primary" color="text-inverted-default">
                Забронирована
              </Label>
            )}
            {hasDecoration && (
              <Label background="control-main-secondary-default" color="text-primary-default">
                С отделкой
              </Label>
            )}
            {discountLabel && (
              <Label background="accent-positive-secondary" color="accent-positive-primary">
                {discountLabel}
              </Label>
            )}
          </div>
        </div>
        <div className={style['description-cell']}>
          <UIText1 color="current_color">{buildingDeadlineShorten}</UIText1>
        </div>
        <div className={style['description-cell']}>
          <UIText1 color="current_color">{floor}</UIText1>
        </div>
        <div className={style['description-cell']}>
          <div className={style['price']}>
            <div className={style['price-row']}>
              {isBookedFromDeveloper && <IconFunctionalLock16 display="block" color="decorative-magentum" />}
              <UIText1
                color={isBookedFromDeveloper ? 'text-secondary-default' : 'text-primary-default'}
                textAlign="right"
                as="span"
              >
                {priceText}
              </UIText1>
            </div>
            {oldPriceText && <span className={style['old-price']}>{oldPriceText}</span>}
          </div>
        </div>
      </a>
      <div className={style['controls-cell']}>{children}</div>
    </div>
  );
};
